import { useEffect as __mpUseEffect, useState as __mpUseState } from "react";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Favicon: set at load so the browser tab shows the Pixel mark
const __MP_CONTROLS = [{
  "id": "emotion",
  "label": "Emotion",
  "kind": "select",
  "group": "Options",
  "default": "auto",
  "options": [{
    "value": "auto",
    "label": "Auto"
  }, {
    "value": "neutral",
    "label": "Neutral"
  }, {
    "value": "curious",
    "label": "Curious"
  }, {
    "value": "happy",
    "label": "Happy"
  }, {
    "value": "angry",
    "label": "Angry"
  }, {
    "value": "sad",
    "label": "Sad"
  }, {
    "value": "sleepy",
    "label": "Sleepy"
  }, {
    "value": "surprised",
    "label": "Surprised"
  }]
}, {
  "id": "screenScale",
  "label": "Screen Scale",
  "kind": "number",
  "group": "Options",
  "default": 0.78,
  "step": 0.1
}, {
  "id": "faceSide",
  "label": "Face Side",
  "kind": "select",
  "group": "Options",
  "default": "auto",
  "options": [{
    "value": "auto",
    "label": "Auto"
  }, {
    "value": "front",
    "label": "Front"
  }, {
    "value": "back",
    "label": "Back"
  }, {
    "value": "left",
    "label": "Left"
  }, {
    "value": "right",
    "label": "Right"
  }, {
    "value": "top",
    "label": "Top"
  }]
}, {
  "id": "armsMode",
  "label": "Arms Mode",
  "kind": "select",
  "group": "Options",
  "default": "auto",
  "options": [{
    "value": "auto",
    "label": "Auto"
  }, {
    "value": "open",
    "label": "Open"
  }, {
    "value": "closed",
    "label": "Closed"
  }]
}];
function __mpIsValidControlValue(control, value) {
  if (control.kind === 'toggle') return typeof value === 'boolean';
  if (control.kind === 'number') {
    return typeof value === 'number' && Number.isFinite(value);
  }
  if (typeof value !== 'string' || value.length > 10000) return false;
  if (control.kind === 'select') {
    return control.options?.some(option => option.value === value) ?? false;
  }
  if (control.kind === 'color') {
    return /^#[0-9a-f]{6}$/i.test(value);
  }
  return true;
}
function __MPControlsRoot() {
  const [overrides, setOverrides] = __mpUseState({});
  __mpUseEffect(() => {
    const handleValues = event => {
      const nextValues = event.detail?.values;
      if (!nextValues || typeof nextValues !== 'object' || Array.isArray(nextValues)) {
        return;
      }
      const normalized = {};
      for (const control of __MP_CONTROLS) {
        const value = nextValues[control.id];
        if (__mpIsValidControlValue(control, value)) {
          normalized[control.id] = value;
        }
      }
      setOverrides(normalized);
    };
    const announceControls = () => {
      window.dispatchEvent(new CustomEvent('magicpatterns:controls-ready', {
        detail: {
          controls: __MP_CONTROLS
        }
      }));
    };
    window.addEventListener('magicpatterns:controls-values', handleValues);
    window.addEventListener('magicpatterns:controls-request', announceControls);
    announceControls();
    return () => {
      window.removeEventListener('magicpatterns:controls-values', handleValues);
      window.removeEventListener('magicpatterns:controls-request', announceControls);
    };
  }, []);
  return <App {...overrides} />;
}
const FAVICON = "https://cdn.magicpatterns.com/uploads/9QSXL92JifyHaoVZ7zuRHM/6ade21fce2dc8606047e6c22_Gruppe_9505678.png";
document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach(el => el.remove());
["icon", "apple-touch-icon"].forEach(rel => {
  const link = document.createElement("link");
  link.rel = rel;
  link.type = "image/png";
  link.href = FAVICON;
  document.head.appendChild(link);
});
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<__MPControlsRoot />);
}